import React from 'react'
import { Box, Grid, Hidden, Link, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { mutualTheme } from '~/utils/theme'
import MutualLogo from '~/assets/images/logomutual.svg'
import AuthTemplateBG from '~/assets/images/authTemplate-bg.svg'
import { BackButton } from '~/components'
import clxs from 'clsx'
import { useIsSmallScreen, useModal } from '~/hooks'
import { InfoModal } from './components/InfoModal'

const useStyles = makeStyles({
  container: {
    flex: 1,
    height: '100vh',
    display: 'flex'
  },
  backButtonContainer: {
    display: 'flex',
    alignSelf: 'flex-start',
    marginBottom: mutualTheme.spacing(4)
  },
  formColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginTop: mutualTheme.spacing(2),
    [mutualTheme.breakpoints.down('lg')]: {
      marginTop: mutualTheme.spacing(1)
    }
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    flex: 1,
    overflow: 'scroll',
    paddingTop: mutualTheme.spacing(3),
    width: 470,
    [mutualTheme.breakpoints.down('lg')]: {
      maxWidth: 300,
      paddingTop: mutualTheme.spacing(2)
    },
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  logoMutual: {
    marginBottom: mutualTheme.spacing(10),
    [mutualTheme.breakpoints.down('sm')]: {
      marginBottom: mutualTheme.spacing(4)
    }
  },
  link: {
    cursor: 'pointer',
    color: mutualTheme.palette.secondary.main
  },
  title: {
    marginBottom: mutualTheme.spacing(2),
    color: mutualTheme.palette.mutualBlue.main
  },
  description: {
    lineHeight: '24px'
  },
  createAccountContainer: {
    flex: 1,
    display: 'flex',
    textAlign: 'center',
    alignItems: 'flex-end',
    justifyContent: 'center',
    paddingTop: mutualTheme.spacing(3),
    paddingBottom: mutualTheme.spacing(3),
    [mutualTheme.breakpoints.down('lg')]: {
      alignItem: 'center',
      paddingBottom: mutualTheme.spacing(2)
    }
  },
  createAccountText: {
    fontWeight: 500,
    color: mutualTheme.palette.secondary.main,
    [mutualTheme.breakpoints.down('lg')]: {
      maxWidth: 300
    }
  },
  imageColumn: {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    // height: '100vh',
    backgroundPosition: 'center right',
    backgroundImage: `url(${AuthTemplateBG})`
  }
})

export type AuthTemplateViewProps = {
  title?: string,
  description?: string,
  onBackButtonClick?: () => void,
  hideLinkToCreateNewAccount?: boolean
}

export const AuthTemplateView: React.FC<AuthTemplateViewProps> = (props) => {
  const { title, description, onBackButtonClick, children, hideLinkToCreateNewAccount } = props
  const classes = useStyles()
  const isSmallScreen = useIsSmallScreen()

  const [isModalOpen, toggleModal] = useModal()

  return (
    <Box className={classes.container}>
      <Grid container className={classes.formColumn} item>
        <Box className={classes.form}>
          <img
            src={MutualLogo}
            alt='LogoMutual'
            width={isSmallScreen ? 50 : 62}
            height={isSmallScreen ? 50 : 62}
            className={classes.logoMutual}
          />
          {onBackButtonClick && (
            <BackButton onBackButtonClick={onBackButtonClick} className={classes.backButtonContainer} />
          )}
          <Typography variant={isSmallScreen ? 'airbnbH2' : 'airbnbH1'} className={classes.title}>
            {title}
          </Typography>
          <Typography variant={isSmallScreen ? 'airbnbBody2' : 'airbnbBody1'} className={classes.description}>{description}</Typography>
          {children}
          {!hideLinkToCreateNewAccount && (
            <Box className={classes.createAccountContainer}>
              <Link onClick={toggleModal} className={clxs(classes.link)}>
                <Typography variant={isSmallScreen ? 'airbnbBody3' : 'airbnbBody2'} className={classes.createAccountText}>
                  Não tem uma conta? Clique aqui e solicite seu empréstimo
                </Typography>
              </Link>
            </Box>
          )}
        </Box>
      </Grid>

      <Hidden mdDown>
        <Grid container item className={classes.imageColumn} />
      </Hidden>

      <InfoModal isModalOpen={isModalOpen} toggleModal={toggleModal} />
    </Box>
  )
}
